module.exports = __webpack_public_path__ + "99c47aa21ef47a981fcc662f658f4c96.pdf";